/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable no-useless-catch */
import {
  COD_ORDERS,
  ORDERS_URL,
  COD_ORDERS_OLD,
  TPL_BULK_UPDATE_URL,
  ADMIN_3PL_NOT_REMITTED_ORDERS,
  ADMIN_CLIENT_ORDERS_EXPORT_URL,
  ADMIN_3PL_CHARGES_EXPORT_URL,
  ADMIN_CLIENT_ORDERS_PRINT_LABEL_URL,
  ADMIN_CLIENT_ORDERS_PRINT_INVOICE_URL,
  ADMIN_CLIENT_ORDERS_URL,
  ADMIN_COD_STATUS,
  ADMIN_ORDER_URL,
  ADMIN_SCAN_SUMMARY_ORDERS_URL,
  ADMIN_CLIENT_ORDERS_PRINT_3PL_LABEL_URL,
  ADMIN_SCAN_UNDELIVERY_URL,
  ADMIN_GET_ORDER_STATUS,
  ADMIN_UPDATE_ORDER_STATUS,
  ADMIN_MARK_ORDER_DELETE,
  ADMIN_ORDERS_GENERATE_3PL_LABEL_BULK_URL,
  ADMIN_CLIENT_ORDERS_PRINT_AMAZON_LABEL_URL,
  ADMIN_CLIENT_ORDERS_WMS_PUSH_URL,
  ADMIN_UPDATE_POD_ORDERS_URL,
  ADMIN_CLIENT_ORDERS_PRINT_AIDUK_LABEL_URL,
  ADMIN_CLIENT_ORDERS_PRINT_ESNAD_LABEL_URL,
} from "../constants/url.constant";

import { API } from "../api";
import { setError } from "./Indicator";

export const REQUEST_SHIPING_LIST = "REQUEST_SHIPING_LIST";
export const RESET_INITIALIZE_SHIPING_LIST = "RESET_INITIALIZE_SHIPING_LIST";
export const SET_SHIPING_LIST = "SET_SHIPING_LIST";
export const REQUEST_SHIPMENT_ORDER_DETAIL = "REQUEST_SHIPMENT_ORDER_DETAIL";
export const UPDATE_BULK_3PL = "UPDATE_BULK_3PL";

export const resetShipingList = () => {
  return {
    type: RESET_INITIALIZE_SHIPING_LIST
  };
};

export const setShipingList = (data) => {
  return {
    type: SET_SHIPING_LIST,
    payload: data
  };
};

/**
 * Get all orders for given filter
 * @param {*} filter
 */
export const shipingList = (filter) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPING_LIST });
    try {
      const res = await API.post(ADMIN_CLIENT_ORDERS_URL, filter);
      dispatch(setShipingList(res));
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

export const updatePODOrders = (filter) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPING_LIST });
    try {
      const res = await API.post(ADMIN_UPDATE_POD_ORDERS_URL, filter);
      dispatch(setShipingList(res));
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * update COD status
 * @param {*} data
 */
export const uploadPOD = async (data) => {
  try {
    return await API.put(ADMIN_UPDATE_POD_ORDERS_URL, data);
  } catch (error) {
    throw error;
  }
};

export const updateBulk3PL = (body) => {
  return async (dispatch) => {
    try {
      await API.put(TPL_BULK_UPDATE_URL, body);
      // TODO: need to check why order list API calls 2 times
      // dispatch({ type: UPDATE_BULK_3PL, payload: { body } });
      // dispatch({ type: REQUEST_SHIPING_LIST });
    } catch (error) {
      throw error;
    }
  };
};

export const pushToWMS = (body) => {
  return async (dispatch) => {
    try {
      return await API.post(ADMIN_CLIENT_ORDERS_WMS_PUSH_URL, body);
    } catch (error) {
      throw error;
    }
  };
}

/**
 * update COD status
 * @param {*} filter
 */
export const updateRemittanceStatus = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.put(ADMIN_COD_STATUS, filter);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

/**
 * Get all orders for given filter with total COD
 * @param {*} filter
 */
export const CODShipingList = (filter) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPING_LIST });
    try {
      const res = await API.post(COD_ORDERS, filter);
      dispatch(setShipingList(res));
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * Get all orders for given filter with total COD
 * @param {*} filter
 */
export const CODShipingListOld = (filter) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPING_LIST });
    try {
      const res = await API.post(COD_ORDERS_OLD, filter);
      dispatch(setShipingList(res));
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * Get all orders for given filter with 3PL NOT REMITTED orders
 * @param {*} filter
 */
export const tplNotRemittedOrders = (filter) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_SHIPING_LIST });
    try {
      const res = await API.post(ADMIN_3PL_NOT_REMITTED_ORDERS, filter);
      dispatch(setShipingList(res));
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * Print Label for given filter
 * @param {*} filter
 */
export const printLabel = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(ADMIN_CLIENT_ORDERS_PRINT_LABEL_URL, filter);
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

export const printAidukLabel = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(ADMIN_CLIENT_ORDERS_PRINT_AIDUK_LABEL_URL, filter);
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

export const printEsnadLabel = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(ADMIN_CLIENT_ORDERS_PRINT_ESNAD_LABEL_URL, filter);
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * Print Invoice for given filter
 * @param {*} filter
 */
export const printInvoice = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(ADMIN_CLIENT_ORDERS_PRINT_INVOICE_URL, filter);
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * Print Amazon Label for given filter
 * @param {*} filter
 */
export const printAmazonLabel = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(ADMIN_CLIENT_ORDERS_PRINT_AMAZON_LABEL_URL, filter);
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

export const print3PLLabel = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(
        ADMIN_CLIENT_ORDERS_PRINT_3PL_LABEL_URL,
        filter
      );
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

export const generate3PLLabel = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(
        ADMIN_ORDERS_GENERATE_3PL_LABEL_BULK_URL,
        filter
      );
      return res;
    } catch (error) {
      console.log("generate3PLLabel: error: ", error);
      // dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

/**
 * Export excel for given filter
 * @param {*} filter
 */
export const excelExport = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(ADMIN_CLIENT_ORDERS_EXPORT_URL, filter);
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * Export excel for given filter
 * @param {*} filter
 */
export const tplChargesExcelExport = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(ADMIN_3PL_CHARGES_EXPORT_URL, filter);
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * Export Scan Summary orders excel for given filter
 * @param {*} filter
 */
export const scanSummaryExcelExport = (filter) => {
  return async (dispatch) => {
    try {
      const res = await API.post(ADMIN_SCAN_SUMMARY_ORDERS_URL, filter);
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

export const scanUndelivery = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(ADMIN_SCAN_UNDELIVERY_URL, data);
      return res;
    } catch (error) {
      console.log(error);
      dispatch(setError("Something went wrong!"));
    }
  };
}

/**
 * Fetch Delivery proof photo/image link
 * @param {*} AWBNo 
 * @returns 
 */
export const getDeliveryProofLink = (AWBNo) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${ADMIN_ORDER_URL}/${AWBNo}/pod-proof`);
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

/**
 * Fetch Delivery proof photo/image link
 * @param {*} AWBNo 
 * @returns 
 */
export const getFileLink = (AWBNo, fileId) => {
  return async (dispatch) => {
    try {
      return await API.get(`${ORDERS_URL}/${AWBNo}/get-file/${fileId}`);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
    }
  };
};

export const getBulkUpdateStatuses = (data) => {
  return async (dispatch) => {
    try {
      return await API.get(ADMIN_GET_ORDER_STATUS, data);
    } catch (error) {
      dispatch(setError("Something went wrong!"));
    }
  };
};

export const updateOrderStatus = (data) => {
  return async (dispatch) => {
    try {
      return await API.put(ADMIN_UPDATE_ORDER_STATUS, data);
    } catch (error) {
      dispatch(setError("Something went wrong!"));
    }
  };
};

export const markOrderDelete = (data) => {
  return async (dispatch) => {
    try {
      return await API.put(ADMIN_MARK_ORDER_DELETE, data);
    } catch (error) {
      dispatch(setError("Something went wrong!"));
    }
  };
};

export const sendOrderFiles = (AWBNo, data) => {
  return async (dispatch) => {
    try {
      return await API.post(`${ORDERS_URL}/${AWBNo}/send-files`, data);
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  columns: [],
  rows: [],
  totalRows: 0,
  order: null,
  totalCODAmount: 0,
  totalAmountCollected: 0
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case RESET_INITIALIZE_SHIPING_LIST:
      return initialState;
    case REQUEST_SHIPING_LIST:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    case SET_SHIPING_LIST:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count,
        totalCODAmount: payload.totalCODAmount,
        totalAmountCollected: payload.totalAmountCollected
      };
    case UPDATE_BULK_3PL:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
}
